<main role="main">
  <router-outlet></router-outlet>
  <sui-toaster position="bottom-center"></sui-toaster>
</main>
